
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action} from 'vuex-class'
import {DOWNLOAD_INVOICE, FETCH_INVOICES,} from '@/store/action-types'
import {Invoice} from '@/model/Invoice'

@Component({
  components: {}
})
export default class BillingPage extends Vue {
  @Action(FETCH_INVOICES) fetchInvoices!: ({ (): Promise<Invoice[]> })
  @Action(DOWNLOAD_INVOICE) downloadInvoice!: ({ (invoice: Invoice): Promise<void> })

  private fetchInProgress: boolean = false
  private currentInvoiceToDownload: Invoice|null = null
  private invoices: Invoice[] = []

  get statusIconBoxClass(): string {
    return this.$vuetify.breakpoint.mdAndUp ? 'icon-box-lg' : 'icon-box-sm'
  }

  getInvoiceName(invoice: Invoice): string {
    let name = invoice.name

    // specificka logika pre mesacne vyuctovania,
    // skracuje sa nazov
    if (invoice.name.includes(',')) {
      name = invoice.name.substr(invoice.name.lastIndexOf(',') + 1).trim()
    }

    return name
  }

  async onInvoiceItemClick(invoice: Invoice): Promise<void> {
    if (!this.currentInvoiceToDownload) {
      try {
        this.currentInvoiceToDownload = invoice
        await this.downloadInvoice(invoice)
      } catch (e) {
        // TODO
      } finally {
        this.currentInvoiceToDownload = null
      }
    }
  }

  async fetchData(): Promise<void> {
    try {
      this.fetchInProgress = true
      this.invoices = await this.fetchInvoices()
    } catch (e) {
      // TODO
    } finally {
      this.fetchInProgress = false
    }
  }

  mounted(): void {
    this.fetchData()
  }
}
